export default "__VITE_ASSET__BvhoA808__"